/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import ajax from './ajax';
import { fauxAjax } from '../stubs';

const encodeData = data => {
	if (!data) {
		return data;
	}

	if (data instanceof Object) {
		return JSON.stringify(data);
	}

	return data;
};

export const createPromiseRequest = ({
	url,
	data: paramData,
	method = 'GET',
	aip = 'admin',
	isAnonymous,
	stubbed = false
}) => () => {
	const data = encodeData(paramData);
	const fetch = stubbed ? fauxAjax : ajax;
	return new Promise((resolve, reject) => {
		fetch(
			url,
			data,
			method,
			(err, res) => {
				if (err) {
					reject(err);
				} else {
					resolve(res);
				}
			},
			isAnonymous,
			aip
		);
	});
};
